<template>
  <div class="task">
    <tips class="task-tip">
      <div class="task-tip__line"> 1.“1个发货单”代表“1个发货任务”, “1个发货单”可包含“1~N个发货计划单” (“1个发货计划单”一 一对应“1个FBA发补货计划单”)，“1个发货单”将对应“1个物流单” </div>
      <div class="task-tip__line"> 2. 为了亚马逊卖家最大程序地节省运费，本系统可将符合条件的“1~N个FBA发补货计划单”合并为一个“发货单”进行物流发运)； </div>
    </tips>
    <div class="task-top">
      <div class="task-top__name">发货任务</div>
    </div>
    <div class="task-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { WarehouseAllocationNewModule } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'deliveryTask',
  components: {
    Table, tips
  },
  data(){
    return {
      TableHead: WarehouseAllocationNewModule.NEWTASKTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.task{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
  }
}
</style>
